// app/features/customers/utils/storyInitials.ts
// Initials shown in the customer-story card artwork when a story has no logoUrl.
//
// The naive version was `name.split(' ').map(w => w[0]).join('').slice(0, 2)`,
// which takes the first CHARACTER of each word rather than the first LETTER.
// A name like "HowTheF (Internal)" therefore rendered as "H(" at 224px on the
// customers index — four times over, once per internal story. Strip anything
// that isn't alphanumeric before picking the initial so punctuation in a
// display name can never leak into the artwork again.

export function storyInitials(name: string, maxLength = 2): string {
  return name
    .split(/\s+/)
    .map((word) => word.replace(/[^\p{L}\p{N}]/gu, ""))
    .filter(Boolean)
    .map((word) => word[0]?.toUpperCase() ?? "")
    .join("")
    .slice(0, maxLength);
}
